/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Pick_Default_WsInputs */

const en_dr_pick_default_ws = /** @type {(inputs: Dr_Pick_Default_WsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room`)
};

const id_dr_pick_default_ws = /** @type {(inputs: Dr_Pick_Default_WsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room`)
};

/**
* | output |
* | --- |
* | "Design Room" |
*
* @param {Dr_Pick_Default_WsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_pick_default_ws = /** @type {((inputs?: Dr_Pick_Default_WsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Pick_Default_WsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_pick_default_ws(inputs)
	return en_dr_pick_default_ws(inputs)
});